import type { IReqCursorPage, IReqPage, IResCursorPage, IResPage } from '@/types/apis/base'
import type {
  IReqAddThreadCommentRecord,
  IReqReplayForComment,
  IResReplayForCommentRecord,
  IResThreadCommentRecord,
} from '@/types/apis/comments'
import { post } from '@/utils/http'

// 基于剧集的评论列表（一级）
export const apiGetCommentsForThread = (payload: IReqPage<{ EpisodeId: number }>) =>
  post<IResPage<IResThreadCommentRecord>>('/UserClip/AILionDramaV2/GetRootComments', payload)
// 回复基于剧集的评论（一级）
export const apiReplayForThread = (payload: IReqAddThreadCommentRecord) =>
  post<IResThreadCommentRecord>('/UserClip/AILionDramaV2/AddRootComment', payload)

// 基于剧集的评论（二级）
export const apiReplayForComment = (payload: IReqReplayForComment) =>
  post<IResReplayForCommentRecord>('/UserClip/AILionDramaV2/AddReply', payload)
// 查询评论的回复列表(二级)
export const apiGetReplyForComment = (payload: IReqCursorPage) =>
  post<IResCursorPage<IResReplayForCommentRecord>>('/UserClip/AILionDramaV2/GetRepliesExpandByRoot', payload)

// 删除评论
export const apiDeleteComment = (payload: { CommentId: number }) =>
  post('/UserClip/AILionDramaV2/DeleteRootComment', void 0, { params: payload })
// 删除回复
export const apiDeleteReply = (payload: { ReplyId: number }) =>
  post('/UserClip/AILionDramaV2/DeleteReply', void 0, { params: payload })

// 点赞评论/回复
export const apiLikeCommentOrReply = (payload: { targetType: 1 | 2; targetId: number }) =>
  post('/UserClip/AILionDramaV2/LikeComment', payload)
// 取消点赞评论/回复
export const apiUnlikeCommentOrReply = (payload: { targetType: 1 | 2; targetId: number }) =>
  post('/UserClip/AILionDramaV2/UnlikeComment', payload)
